import { motion } from 'framer-motion';
import { Award, GraduationCap } from 'lucide-react';
import { IMAGES } from '../../constants/images';

export const LeadershipHero = () => (
  <section className="py-24 bg-[#f8fafc]" data-testid="leadership-hero">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block px-4 py-2 bg-white rounded-full text-sm font-medium text-[#3b5998] mb-6 shadow-sm">
            Our Leadership
          </span>
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-[#0f172a] leading-tight mb-6">
            Meet the Experts
            <span className="gradient-text block">Behind Your Success</span>
          </h1>
          <p className="text-lg text-[#64748b] leading-relaxed mb-6">
            Our leadership team brings together decades of experience in finance, 
            government subsidies, and banking. With their combined expertise, we've 
            helped over 500 clients achieve their financial goals.
          </p>
          <div className="flex flex-wrap gap-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#3b5998] to-[#00bcd4] flex items-center justify-center text-white">
                <Award size={24} />
              </div>
              <div>
                <p className="font-semibold text-[#0f172a]">30+ Years</p>
                <p className="text-sm text-[#64748b]">Combined Experience</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#3b5998] to-[#00bcd4] flex items-center justify-center text-white">
                <GraduationCap size={24} />
              </div>
              <div>
                <p className="font-semibold text-[#0f172a]">2 CAs</p>
                <p className="text-sm text-[#64748b]">Chartered Accountants</p>
              </div>
            </div>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_tofin-redesign/artifacts/ckva3ztb_FBCover.png"
            alt="Our Founders"
            className="rounded-2xl shadow-2xl w-full"
          />
        </motion.div>
      </div>
    </div>
  </section>
);
